import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'palette/Button';
import { Header } from 'palette/Typography';
import FavoritesCounter from '@common/Favorites/containers/FavoritesCounter';
import FavoriteList from '@common/Favorites/containers/FavoritesList';
import { useTranslation } from '@common/Hooks/useTranslation';
import { useDynamicStickyElement } from '@common/Listing/hooks';
import { openFavorites, openRecents } from '@common/MyLists/store/actions/MyListsActions';
import { RecentsCounter } from '@common/Recents/containers/RecentsCounter';
import RecentsList from '@common/Recents/containers/RecentsList';
import { getStatePropertyItemsCount } from '@helpers/customerHelpers';
import './LeftSidebarLists.scss';

const numberOfItems = 6;

export function LeftSidebarLists() {
    const translate = useTranslation();
    const dispatch = useDispatch();
    const recentsCount = useSelector(({ recents }) => getStatePropertyItemsCount(recents.products));
    const favoritesCount = useSelector(({ favorites }) => getStatePropertyItemsCount(favorites.products));
    const sidebarContent = useRef(null);
    const sidebarContainer = useRef(null);

    useDynamicStickyElement(sidebarContent, sidebarContainer, [recentsCount, favoritesCount], true);

    return (
        <div
            ref={sidebarContainer}
            className="left-sidebar-lists"
        >
            <div
                ref={sidebarContent}
                className="left-sidebar-lists__wrap"
            >
                <div className="left-sidebar-lists__section">
                    <Header
                        color="strong"
                        level="6"
                    >
                        {translate('product.details.recently_viewed.label')}
                    </Header>
                    <RecentsList
                        className="left-sidebar-lists__list"
                        pageSize={numberOfItems}
                    />
                    {
                        recentsCount >= numberOfItems && (
                            <Button
                                isExpanded
                                theme="secondary"
                                onClick={() => dispatch(openRecents())}
                            >
                                {translate('helper.view_all.label')}
                                <RecentsCounter />
                            </Button>
                        )
                    }
                </div>
                <div className="left-sidebar-lists__section">
                    <div className="left-sidebar-lists__section">
                        <Header
                            color="strong"
                            level={6}
                        >
                            {translate('customer.dash_favourites.label')}
                        </Header>
                        <FavoriteList
                            className="left-sidebar-lists__list"
                            pageSize={numberOfItems}
                        />
                        {
                            favoritesCount >= numberOfItems && (
                                <Button
                                    isExpanded
                                    theme="secondary"
                                    onClick={() => dispatch(openFavorites())}
                                >
                                    {translate('helper.view_all.label')}
                                    <FavoritesCounter />
                                </Button>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
